module.exports = __webpack_public_path__ + "img/arrow-up.5eeb95b2.svg";